import React, { useContext, useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Alert from "@mui/material/Alert";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Icon } from "@iconify/react";
import { AuthContext } from "../../context/AuthContextProvider.js";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment";
import { Helmet } from "react-helmet";
import nopreview from "../../assets/images/others/no-preview.png";
import { BlankPreview } from "../../components/BlankPreview";
import OtpInput from "react-otp-input";
import { useForm, Controller } from "react-hook-form";
import Timer from "otp-timer";
import { se } from "date-fns/locale";
import { set } from "lodash";
import Select, { components } from "react-select";
import { API_URL } from "../../config";
import {
  createAbhaConsent,
  getAbhaConsent,
  getConsentData,
  downloadReportFile,
} from "../../api/abha";
import { toast } from "sonner";
import Loader from "../../components/Loader";
import CentreSelect from "../../components/CentreSelect.jsx";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import { CloseIcon } from "stream-chat-react";
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minHeight: "48px",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    boxShadow: "none",
    cursor: "text",
    backgroundColor: "var(--app-surface)",
    padding: "0 8px",
    height: "auto",
    backgroundColor: state.isDisabled ? "var(--app-surface-2)" : "var(--app-surface)",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 4,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontSize: "15px",
    color: "var(--app-text)",
  }),
  singleValue: (provided) => ({
    ...provided,
    backgroundColor: "#fff5e8",
    borderRadius: "8px",
    padding: "4px 8px",
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "15px",
    color: "var(--app-text-muted)",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999999,
    borderRadius: "8px",
    width: "100%",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 999999,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "15px",
    color: "var(--app-text-muted)",
    backgroundColor: state.isSelected
      ? "#F2F2F2"
      : state.isFocused
        ? "var(--app-surface-2)"
        : "white",
    cursor: "pointer",
    padding: "10px 12px",
    borderBottom: "1px solid var(--app-border)",
    fontWeight: state.data.value === "select-all" ? "bold" : "normal",
    borderLeft:
      state.data.value === "select-all" ? "3px solid #007bff" : "none",
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#fff5e8",
    borderRadius: "8px",
    padding: "2px 6px",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "var(--app-text)",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "var(--app-text)",
    ":hover": {
      backgroundColor: "#f5d0a9",
      color: "var(--app-text)",
    },
  }),
};

// Sample data for the multi-step system matching the UI
const sampleData = {
  patient: {
    name: "John Doe",
    gender: "Male",
    dob: "03/03/2000",
    abhaNumber: "897456748674",
    abhaAddress: "89hfhgf8fhdjhdjhg",
  },
  facilities: [
    {
      id: 1,
      name: "Drucare",
      totalRecords: 10,
      status: "Pending",
    },
    {
      id: 2,
      name: "Lorem Ipsum Lorem Ipsum",
      totalRecords: 10,
      status: "Completed",
    },
    {
      id: 3,
      name: "Lorem Ipsum Lorem Ipsum",
      totalRecords: 10,
      status: "Completed",
    },
    {
      id: 4,
      name: "Lorem Ipsum Lorem Ipsum",
      totalRecords: 10,
      status: "Completed",
    },
    {
      id: 5,
      name: "Lorem Ipsum Lorem Ipsum",
      totalRecords: 10,
      status: "Completed",
    },
  ],
  consultations: [
    {
      id: 1,
      date: "28 June 2022",
      type: "OP (Ambulatory) - 1059456",
      category: "Consultation",
    },
    {
      id: 2,
      date: "28 June 2022",
      type: "OP (Ambulatory) - 1059456",
      category: "Diagnostic",
    },
    {
      id: 3,
      date: "28 June 2022",
      type: "OP (Ambulatory) - 1059456",
      category: "Diagnostic",
    },
    {
      id: 4,
      date: "28 June 2022",
      type: "OP (Ambulatory) - 1059456",
      category: "Consultation",
    },
    {
      id: 5,
      date: "28 June 2022",
      type: "OP (Ambulatory) - 1059456",
      category: "Diagnostic",
    },
  ],
  consultationDetails: {
    facility: "Heart Clinic",
    doctor: "Dr. Jane Doe",
    date: "18 June 2022, 3:06 pm",
    type: "OP (Ambulatory) - 1059456",
    email: "johndoe@gmail.com",
    phone: "+91 9876543210",
    bodyVitals: {
      presentIllness: "Cold and cough",
      history: "No History of Illness",
      generalExamination: "Voice is normal",
      vitalSigns: {
        diastolicBP: "80 mm Hg",
        systolicBP: "120 mm Hg",
        temperature: "98 F",
      },
      bodyMeasurements: {
        weight: "70 kg",
        height: "180 cm",
      },
    },
  },
};

const PatientABHA = ({ patient }) => {
  const { user } = useContext(AuthContext);
  const [concentModal, setConcentModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [selectedReport, setSelectedReport] = useState([]);
  const [selectedHealthInfoTypes, setSelectedHealthInfoTypes] = useState([]);
  const [healthInfoFromDate, setHealthInfoFromDate] = useState(null);
  const [healthInfoToDate, setHealthInfoToDate] = useState(null);
  const [consentPurposeCode, setConsentPurposeCode] = useState("");
  const [consentExpiryDateTime, setConsentExpiryDateTime] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [submittingConsent, setSubmittingConsent] = useState(false);
  const [selectedCentre, setSelectedCentre] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [abhaConsent, setAbhaConsent] = useState([]);
  const [consentData, setConsentData] = useState([]);
  const [refreshingConsent, setRefreshingConsent] = useState(false);

  useEffect(() => {
    FetchAbhaConsent();
  }, []);

  const FetchAbhaConsent = async () => {
    try {
      setIsLoading(true);
      const response = await getAbhaConsent({
        abhaAddress: patient?.abhaDetails?.abhaAddress,
      });

      setAbhaConsent(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRefreshConsent = async () => {
    try {
      setRefreshingConsent(true);
      await FetchAbhaConsent();
    } catch (error) {
      // no-op; FetchAbhaConsent handles errors
    } finally {
      setRefreshingConsent(false);
    }
  };

  const handleCentreChange = (selectedOption) => {
    setSelectedCentre(selectedOption);
    setCurrentStep(1);
  };

  const handleHealthInfoTypeChange = (selectedOptions) => {
  if (!selectedOptions || selectedOptions.length === 0) {
    setSelectedHealthInfoTypes([]);
    return;
  }

  const lastSelected = selectedOptions[selectedOptions.length - 1];

  //  SAFETY CHECK
  if (!lastSelected) {
    setSelectedHealthInfoTypes([]);
    return;
  }

  const hasSelectAll = selectedOptions.some(
    (option) => option?.value === "select-all"
  );

  if (lastSelected.value === "select-all") {
    const regularOptions = healthInfoType.filter(
      (option) => option.value !== "select-all"
    );

    const allCurrentlySelected = regularOptions.every((option) =>
      selectedHealthInfoTypes.some(
        (selected) => selected.value === option.value
      )
    );

    if (allCurrentlySelected) {
      setSelectedHealthInfoTypes([]);
    } else {
      setSelectedHealthInfoTypes(regularOptions);
    }
  } else if (hasSelectAll && lastSelected.value !== "select-all") {
    const regularOptions = selectedOptions.filter(
      (option) => option.value !== "select-all"
    );
    setSelectedHealthInfoTypes(regularOptions);
  } else {
    setSelectedHealthInfoTypes(selectedOptions);
  }
};

  const getHealthInfoTypeOptions = () => {
    const regularOptions = healthInfoType.filter(
      (option) => option.value !== "select-all",
    );
    const allSelected = regularOptions.every((option) =>
      selectedHealthInfoTypes.some(
        (selected) => selected.value === option.value,
      ),
    );

    return [
      {
        value: "select-all",
        label: allSelected ? "Clear All" : "Select All",
        isSelected: allSelected,
      },
      ...regularOptions,
    ];
  };

  const getSelectedHealthInfoTypeValues = () => {
    return selectedHealthInfoTypes
      .filter((option) => option.value !== "select-all")
      .map((option) => option.value);
  };

  const handleStepBack = () => {
    if (currentStep > 1) {
      if (currentStep === 2) {
        setSelectedFacility(null);
      } else if (currentStep === 3) {
        setSelectedConsultation(null);
      }
      setCurrentStep(currentStep - 1);
    }
  };

  const handleStepForward = (step, data = null) => {
    if (step === 2) {
      setSelectedFacility(data);
    } else if (step === 3) {
      setSelectedConsultation(data);
    } else if (step === 4) {
      setSelectedReport(data);
    }

    setCurrentStep(step);
  };

  const FetchConsentData = async (id) => {
    try {
      handleStepForward(2);
      const response = await getConsentData({ id });

      if (response.success) {
        toast.success("Consent Data Fetched Successfully", response.data);
        setConsentData(response.data);
      } else {
        toast.error("Failed to Fetch Consent Data");
        setConsentData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handledownloadReportFile = async (filepath) => {
    try {
      const response = await downloadReportFile({ filepath });
    } catch (error) {
      console.error(error);
    }
  };

  const renderStep1 = () => (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
        <h5 className="mb-0">
          <strong>Consent Request List</strong>
        </h5>

        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-added-primary2"
            onClick={handleRefreshConsent}
            disabled={isLoading || refreshingConsent}
          >
            {refreshingConsent ? (
              <Icon icon="line-md:loading-loop" width="18" height="18" />
            ) : (
              <Icon icon="ri:refresh-line" width="18" height="18" />
            )}
          </button>
          <button
            onClick={() => setConcentModal(true)}
            className="btn btn-added-primary"
          >
            Request Consent
          </button>
        </div>
      </div>

      {/* Patient Demographics */}
      <div className="row mb-4">
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              NAME
            </strong>
          </h6>
          <p>
            {patient?.firstName} {patient?.lastName}
          </p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              GENDER
            </strong>
          </h6>
          <p>{patient?.gender}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              DATE OF BIRTH
            </strong>
          </h6>
          <p>{patient?.dateOfBirth}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              ABHA NUMBER
            </strong>
          </h6>
          <p>{patient?.abhaDetails?.abhaNumber}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              ABHA ADDRESS
            </strong>
          </h6>
          <p>{patient?.abhaDetails?.abhaAddress}</p>
        </div>
      </div>
      <hr />

      {abhaConsent?.length > 0 &&
        abhaConsent?.map((consent, index) => (
          <div
            key={index}
            className="card"
            style={{ cursor: "pointer" }}
            onClick={() =>
              consent?.requestStatus === "GRANTED"
                ? FetchConsentData(consent?.id)
                : toast.error("Not Permitted to view this consent")
            }
          >
            <div className="">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <h5 className="mb-2">
                    <strong>
                      {patient?.firstName} {patient?.lastName}
                    </strong>
                  </h5>
                  <p className="mb-3">
                    <strong>HI Type</strong>:
                    {consent.healthInfoType.map((type, index) => (
                      <span key={index}>{type}, </span>
                    ))}
                  </p>
                </div>

                <div className="d-flex flex-column align-items-end gap-3">
                  <Alert
                    type={
                      consent?.requestStatus === "DENIED" ||
                      consent?.requestStatus === "EXPIRED" ||
                      consent?.requestStatus === "FAILED"
                        ? "error"
                        : consent?.requestStatus === "REQUESTED"
                          ? "warning"
                          : consent?.requestStatus === "GRANTED"
                            ? "success"
                            : "info"
                    }
                    style={{ fontSize: "14px" }}
                  >
                    {consent?.requestStatus}
                  </Alert>
                  <i
                    className="fas fa-chevron-right"
                    style={{ fontSize: "20px", color: "#6c757d" }}
                  ></i>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6 className="text-muted">
                    <strong
                      style={{
                        color: "rgb(163, 163, 163)",
                        fontWeight: "800",
                      }}
                    >
                      HEALTH INFO FROM
                    </strong>
                  </h6>
                  <p className="mb-0">
                    {moment(consent.healthInfoFrom).format("DD/MM/YYYY")}
                  </p>
                </div>
                <div className="col">
                  <h6 className="text-muted">
                    <strong
                      style={{
                        color: "rgb(163, 163, 163)",
                        fontWeight: "800",
                      }}
                    >
                      HEALTH INFO TO
                    </strong>
                  </h6>
                  <p className="mb-0">
                    {moment(consent.healthInfoTo).format("DD/MM/YYYY")}
                  </p>
                </div>
                <div className="col">
                  <h6 className="text-muted">
                    <strong
                      style={{
                        color: "rgb(163, 163, 163)",
                        fontWeight: "800",
                      }}
                    >
                      CREATED ON
                    </strong>
                  </h6>
                  <p className="mb-0">
                    {consent?.requestStatus === "REVOKED22" ? (
                      <>
                        {moment(consent.createdAt).format("DD/MM/YYYY")} <br />
                        {moment(consent.createdAt).format("h:mm a")}
                      </>
                    ) : (
                      moment(consent.createdAt).format("DD/MM/YYYY, h:mm a")
                    )}
                  </p>
                </div>

                {(consent?.requestStatus === "GRANTED" ||
                  consent?.requestStatus === "REVOKED") && (
                  <>
                    <div className="col">
                      <h6 className="text-muted">
                        <strong
                          style={{
                            color: "rgb(163, 163, 163)",
                            fontWeight: "800",
                          }}
                        >
                          GRANTED ON
                        </strong>
                      </h6>
                      <p className="mb-0">
                        {consent?.requestStatus === "REVOKED22" ? (
                          <>
                            {moment(consent.grantAt).format("DD/MM/YYYY")}{" "}
                            <br />
                            {moment(consent.grantAt).format("h:mm a")}
                          </>
                        ) : (
                          moment(consent.grantAt).format("DD/MM/YYYY, h:mm a")
                        )}
                      </p>
                    </div>

                    <div className="col">
                      <h6 className="text-muted">
                        <strong
                          style={{
                            color: "rgb(163, 163, 163)",
                            fontWeight: "800",
                          }}
                        >
                          EXPIRY ON
                        </strong>
                      </h6>
                      <p className="mb-0">
                        {consent?.requestStatus === "REVOKED22" ? (
                          <>
                            {moment(consent.consentExpiry).format("DD/MM/YYYY")}{" "}
                            <br />
                            {moment(consent.consentExpiry).format("h:mm a")}
                          </>
                        ) : (
                          moment(consent.consentExpiry).format(
                            "DD/MM/YYYY, h:mm a",
                          )
                        )}
                      </p>
                    </div>
                  </>
                )}

                {consent?.requestStatus === "DENIED" && (
                  <>
                    <div className="col">
                      <h6 className="text-muted">
                        <strong
                          style={{
                            color: "rgb(163, 163, 163)",
                            fontWeight: "800",
                          }}
                        >
                          DENIED ON
                        </strong>
                      </h6>
                      <p className="mb-0">
                        {moment(consent.deniedAt).format("DD/MM/YYYY, h:mm a")}
                      </p>
                    </div>
                  </>
                )}

                {consent?.requestStatus === "REVOKED" && (
                  <>
                    <div className="col">
                      <h6 className="text-muted">
                        <strong
                          style={{
                            color: "rgb(163, 163, 163)",
                            fontWeight: "800",
                          }}
                        >
                          REVOKED ON
                        </strong>
                      </h6>
                      <p className="mb-0">
                        {moment(consent.revokedAt).format("DD/MM/YYYY")}
                        {/* <br/> */}
                        {moment(consent.revokedAt).format("h:mm a")}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
    </>
  );

  const renderStep2 = () => (
    <>
      <h1></h1>
      <div className="d-flex align-items-center mb-4">
        <i
          className="fas fa-chevron-left me-3"
          style={{ cursor: "pointer", fontSize: "18px" }}
          onClick={handleStepBack}
        ></i>
        <h5 className="mb-0">
          <strong>Patient Data</strong>
        </h5>
      </div>

      {/* Patient Demographics */}
      <div className="row mb-4">
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              NAME
            </strong>
          </h6>
          <p>
            {patient?.firstName} {patient?.lastName}
          </p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              GENDER
            </strong>
          </h6>
          <p>{patient?.gender}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              DATE OF BIRTH
            </strong>
          </h6>
          <p>{patient?.dateOfBirth}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              ABHA NUMBER
            </strong>
          </h6>
          <p>{patient?.abhaDetails?.abhaNumber}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              ABHA ADDRESS
            </strong>
          </h6>
          <p>{patient?.abhaDetails?.abhaAddress}</p>
        </div>
      </div>
      <hr />
      {/* Facility Cards */}
      <div className="row">
        {consentData?.length > 0 &&
          consentData?.map((facility, index) => (
            <div key={facility.id} className="col-12 ">
              <div
                className="card"
                style={{
                  cursor: "pointer",
                  border:
                    index === 1 ? "2px solid #007bff" : "1px solid #dee2e6",
                }}
                onClick={() => handleStepForward(3, facility)}
              >
                <div className="">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-1">
                        <strong>{facility?.hip?.name}</strong>
                      </h6>
                      <p className="mb-0 text-muted">
                        Total Records : {facility?.careContexts?.length}
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      {facility?.requestStatus === "Pending" && (
                        <Alert severity="warning" style={{ fontSize: "14px" }}>
                          {facility?.requestStatus}
                        </Alert>
                      )}
                      <i
                        className="fas fa-chevron-right"
                        style={{ fontSize: "18px", color: "#6c757d" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );

  const renderStep3 = () => (
    <>
      <div className="d-flex align-items-center mb-4">
        <i
          className="fas fa-chevron-left me-3"
          style={{ cursor: "pointer", fontSize: "18px" }}
          onClick={handleStepBack}
        ></i>
        <h4 className="mb-0">{selectedConsultation?.hip?.name}</h4>
      </div>

      {/* Patient Demographics */}
      <div className="row mb-4">
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              NAME
            </strong>
          </h6>
          <p>
            {patient?.firstName} {patient?.lastName}
          </p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              GENDER
            </strong>
          </h6>
          <p>{patient?.gender}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              DATE OF BIRTH
            </strong>
          </h6>
          <p>{patient?.dateOfBirth}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              ABHA NUMBER
            </strong>
          </h6>
          <p>{patient?.abhaDetails?.abhaNumber}</p>
        </div>
        <div className="col">
          <h6>
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              ABHA ADDRESS
            </strong>
          </h6>
          <p>{patient?.abhaDetails?.abhaAddress}</p>
        </div>
      </div>
      <hr />
      {/* Consultation/Diagnostic Events */}
      <div className="row">
        {selectedConsultation?.careContexts?.map((consultation) => (
          <div key={consultation.id} className="col-12">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => handleStepForward(4, consultation)}
            >
              <div className="">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-1 ">
                      <strong>{consultation?.dateReadable}</strong>
                    </h6>
                    <p className="mb-0">
                      {consultation?.title} -{" "}
                      {consultation?.careContextReference}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <Alert
                      type={
                        consultation.reportType === "OPConsultation"
                          ? "warning"
                          : consultation.reportType === "Prescription"
                            ? "success"
                            : consultation.reportType === "Invoice"
                              ? "error"
                              : consultation.reportType === "DischargeSummary"
                                ? "info"
                                : "success"
                      }
                    >
                      {consultation?.reportType}
                    </Alert>
                    <i
                      className="fas fa-chevron-right"
                      style={{ fontSize: "18px", color: "#6c757d" }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const renderStep4 = () => (
    <>
      <div className="d-flex align-items-center mb-4">
        <i
          className="fas fa-chevron-left me-3"
          style={{ cursor: "pointer", fontSize: "18px" }}
          onClick={handleStepBack}
        ></i>
        <h5 className="mb-0">
          {selectedConsultation?.hip?.name} - {selectedReport?.dateReadable} -{" "}
          {selectedReport?.title}
        </h5>
        <div className="ms-auto">
          <span
            className={`badge px-3 py-2 ${
              selectedConsultation?.category === "Consultation"
                ? "bg-warning"
                : "bg-primary"
            }`}
          >
            {selectedConsultation?.category}
          </span>
        </div>
      </div>

      {/* Main heading */}
      <h6 className="mb-3">
        <strong>{selectedConsultation?.hip?.name}</strong>
      </h6>
      <p className="mb-4">
        {selectedReport?.dateReadable} | {selectedReport?.reportType} -{" "}
        {selectedReport?.careContextReference}
      </p>

      {/* Facility and Patient Details */}
      <div className="row mb-4">
        <div className="col-md-4">
          <h6 className="text-muted mb-3">
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              FACILITY DETAILS
            </strong>
          </h6>
          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <p className="mb-1">
              {selectedConsultation?.hip?.name} |{" "}
              {selectedReport?.doctorData?.length > 0
                ? selectedReport?.doctorData[0]?.name
                : "--"}
            </p>
          </div>
        </div>
        <div className="col-md-8">
          <h6 className="text-muted mb-3">
            <strong style={{ color: "rgb(163, 163, 163)", fontWeight: "800" }}>
              PATIENT DETAILS
            </strong>
          </h6>
          <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
            <p className="mb-1">
              {patient?.firstName} {patient?.lastName} ({patient?.gender})
            </p>
            <p className="mb-1">DOB: {patient?.dateOfBirth}</p>
            <p className="mb-1">{patient?.email}</p>
            <p className="mb-0">{patient?.phoneNumber}</p>
          </div>
        </div>
      </div>
      <hr />
      {selectedReport?.sections?.length > 0 && (
        <div>
          {selectedReport.sections.map((section, index) => (
            <div key={section.id || index} style={{ marginBottom: "12px" }}>
              <Accordion
                defaultExpanded={index === 0}
                sx={{ background: "var(--app-surface)" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {section.title}
                </AccordionSummary>
                <AccordionDetails>
                {section.resourceName !== "DocumentReference" ? (
                  Array.isArray(section?.formattedData) ? (
                    section.formattedData.map((block, blockIndex) => (
                      <div key={blockIndex} style={{ whiteSpace: "pre-line" }}>
                        {block}
                      </div>
                    ))
                  ) : (
                    <div style={{ whiteSpace: "pre-line" }}>
                      {section?.formattedData || ""}
                    </div>
                  )
                ) : (
                  <>
                    {section?.entries.map((entry, entryIndex) => (
                      <div className="mt-3" key={entryIndex}>
                        <p
                          onClick={() =>
                            handledownloadReportFile(entry.filePath)
                          }
                          // to={API_URL+'get-pushed-pdf?filepath='+entry.filePath}
                          target="_blank"
                          className="text-primary text-decoration-underline"
                        >
                          {entry.fileName}
                        </p>
                      </div>
                    ))}
                  </>
                )}
              </AccordionDetails>
              </Accordion>
            </div>
          ))}
        </div>
      )}
    </>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      default:
        return renderStep1();
    }
  };

  const validateConsentForm = () => {
    const errors = {};
    const abhaAddress = patient?.abhaDetails?.abhaAddress;
    if (!abhaAddress) {
      errors.abhaAddress = "Missing ABHA address";
    }
    if (!healthInfoFromDate) {
      errors.healthInfoFrom = "Health Info From is required";
    }
    if (!healthInfoToDate) {
      errors.healthInfoTo = "Health Info To is required";
    }
    if (
      healthInfoFromDate &&
      healthInfoToDate &&
      healthInfoFromDate > healthInfoToDate
    ) {
      errors.healthInfoTo = "To date must be after From date";
    }
    const types = getSelectedHealthInfoTypeValues();
    if (!types || types.length === 0) {
      errors.healthInfoType = "Select at least one health info type";
    }
    if (!consentPurposeCode) {
      errors.consentPurposeCode = "Purpose of consent is required";
    }
    if (!consentExpiryDateTime) {
      errors.consentExpiry = "Consent expiry is required";
    } else if (new Date(consentExpiryDateTime) <= new Date()) {
      errors.consentExpiry = "Consent expiry must be in the future";
    }
    if (!selectedCentre) {
      errors.selectedCentre = "Centre is required";
    }
    return errors;
  };

  const handleConsentSubmit = async () => {
    const errors = validateConsentForm();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      toast.error("Please fix the errors in the form");
      return;
    }

    const payload = {
      abhaAddress: patient?.abhaDetails?.abhaAddress,
      healthInfoFrom: moment(healthInfoFromDate).format("DD-MM-YYYY"),
      healthInfoTo: moment(healthInfoToDate).format("DD-MM-YYYY"),
      healthInfoType: getSelectedHealthInfoTypeValues(),
      consentPurposeCode: consentPurposeCode,
      consentExpiry: moment(consentExpiryDateTime)
        .seconds(0)
        .format("DD-MM-YYYY HH:mm:ss"),
      centerId: selectedCentre?.value,
    };

    try {
      setSubmittingConsent(true);
      const response = await createAbhaConsent(payload);
      if (response?.success) {
        toast.success(response?.message || "Consent request created");
        FetchAbhaConsent();
        setConcentModal(false);
        // reset form
        setHealthInfoFromDate(null);
        setHealthInfoToDate(null);
        setSelectedHealthInfoTypes([]);
        setConsentPurposeCode("");
        setConsentExpiryDateTime(null);
        setFormErrors({});
      } else {
        toast.error(response?.message || "Failed to create consent request");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || error?.message || "An error occurred",
      );
    } finally {
      setSubmittingConsent(false);
    }
  };

  const formatOptionLabel2 = (option, { context }) => {
  if (context === "value") {
    return option.label; // IMPORTANT: show label in chip
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* your custom UI for dropdown */}
      {option.label}
    </div>
  );
};

  const CustomMultiValueLabel = (props) => {
    return (
      <components.MultiValueLabel {...props}>
        <strong> {props.data.label}</strong>
      </components.MultiValueLabel>
    );
  };

  const healthInfoType = [
    { value: "select-all", label: "Select All" },
    { value: "OPConsultation", label: "OPConsultation" },
    { value: "Prescription", label: "Prescription" },
    { value: "DiagnosticReport", label: "DiagnosticReport" },
    { value: "DischargeSummary", label: "DischargeSummary" },
    { value: "ImmunizationRecord", label: "ImmunizationRecord" },
    { value: "HealthDocumentRecord", label: "HealthDocumentRecord" },
    { value: "WellnessRecord", label: "WellnessRecord" },
    { value: "Invoice", label: "Invoice" },
  ];

  return (
    <>
      <Helmet>
        <title>Spandan - Patient ABHA</title>
      </Helmet>
      {isLoading ? (
        <div className="container-fluid">
          <Loader />
        </div>
      ) : abhaConsent?.length > 0 ? (
        <div className="container-fluid">{renderCurrentStep()}</div>
      ) : (
        <div
          className="content"
          style={{
            height: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            margin: "40px 0",
          }}
        >
          <img
            src={nopreview}
            alt="img"
            style={{
              width: "150px",
            }}
          />
          <h5 className="mt-3">No ABHA Reports available</h5>
          <p>
            <center>
              In order to view the ABHA reports of this patient, please request
              <br /> consent for the same from the patient
            </center>
          </p>

          <button
            onClick={() => {
              setConcentModal(true);
            }}
            className="btn btn-added-primary"
          >
            Request Consent
          </button>
        </div>
      )}

      <Dialog
        open={concentModal}
        onClose={() => setConcentModal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 4, 
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            px: 3,
            pt: 3,
            pb: 2,
            fontWeight: 700,
            fontSize: "24px",
          }}
        >
          Consent Request Form
          <IconButton
            aria-label="close"
            onClick={() => setConcentModal(false)}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: (theme) => theme.palette.grey[600],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          style={{
            maxHeight: "70vh",
            overflowY: "auto !important",
            paddingBottom: "12px",
          }}
        >
          <Box
            sx={{
              bgcolor: "var(--app-border)",
              borderRadius: 2,
              p: { xs: 2, sm: 3 },
              mb: 3,
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(4, 1fr)",
              },
              gap: { xs: 2, sm: 2.5, md: 3 },
            }}
          >
            {/* Patient Name + Basic Info (takes full row) */}
            <Box sx={{ gridColumn: "1 / -1" }}>
              <Typography
                variant="h6"
                fontWeight={700}
                color="var(--app-text)"
                fontSize={18}
              >
                {patient?.firstName} {patient?.lastName}
              </Typography>

              <Typography
                variant="body2"
                fontWeight={600}
                color="var(--app-text)"
                fontSize={15}
              >
                {patient?.gender} | DOB: {patient?.dateOfBirth}
              </Typography>
            </Box>

            {/* ABHA Number */}
            <Box>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                  color: "var(--app-text-muted)",
                  fontSize: 13,
                  fontStyle: "extrabold",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                ABHA Number
              </Typography>

              <Typography
                variant="body1"
                fontWeight={600}
                color="var(--app-text)"
                fontSize={15}
              >
                {patient?.abhaDetails?.abhaNumber}
              </Typography>
            </Box>

            {/* ABHA Address */}
            <Box>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                  color: "var(--app-text-muted)",
                  fontSize: 13,
                  fontStyle: "extrabold",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                ABHA Address
              </Typography>

              <Typography
                variant="body1"
                fontWeight={600}
                color="var(--app-text)"
                fontSize={15}
              >
                {patient?.abhaDetails?.abhaAddress}
              </Typography>
            </Box>

            {/* Contact Number */}
            <Box>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                  color: "var(--app-text-muted)",
                  fontSize: 13,
                  fontStyle: "extrabold",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                  whiteSpace: "nowrap",
                }}
              >
                Contact Number
              </Typography>

              <Typography
                variant="body1"
                fontWeight={600}
                color="var(--app-text)"
                fontSize={15}
              >
                {patient?.phoneNumber}
              </Typography>
            </Box>
          </Box>

          <Box mt={4}>
            {/* Select Centre */}
            <Box mb={3}>
              <Typography fontSize={15} fontWeight={400} color="var(--app-text-muted)" mb={1}>
                Select Centre <span style={{ color: "red" }}>*</span>
              </Typography>

              <CentreSelect
                value={selectedCentre}
                onChange={handleCentreChange}
                placeholder="Select Centre"
                width="100%"
                label="Select Centre"
                showSelectedValue
                abhaConsent
              />

              {formErrors.selectedCentre && (
                <Typography color="error" fontSize={13} mt={0.5}>
                  {formErrors.selectedCentre}
                </Typography>
              )}
            </Box>

            {selectedCentre?.isAbhaVerified ? (
              <>
                {/* Row Wrapper (responsive without Grid) */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 3,
                    mb: 3,
                  }}
                >
                  {/* Health Info From */}
                  <Box flex={1}>
                    <Typography
                      fontSize={15}
                      fontWeight={400}
                      color="var(--app-text-muted)"
                      mb={1}
                    >
                      Health Info From <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker format="dd/MM/yyyy" value={healthInfoFromDate} onChange={setHealthInfoFromDate} shouldDisableDate={(date) => date > new Date()} slotProps={{ textField: { fullWidth: true, size: "small", placeholder: "DD/MM/YYYY" } }} />
                    </LocalizationProvider>
                    {formErrors.healthInfoFrom && (
                      <Typography color="error" fontSize={13} mt={0.5}>
                        {formErrors.healthInfoFrom}
                      </Typography>
                    )}
                  </Box>

                  {/* Health Info To */}
                  <Box flex={1}>
                    <Typography
                      fontSize={15}
                      fontWeight={400}
                      color="var(--app-text-muted)"
                      mb={1}
                    >
                      Health Info To <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker format="dd/MM/yyyy" value={healthInfoToDate} onChange={setHealthInfoToDate} shouldDisableDate={(date) => date > new Date()} slotProps={{ textField: { fullWidth: true, size: "small", placeholder: "DD/MM/YYYY" } }} />
                    </LocalizationProvider>
                    {formErrors.healthInfoTo && (
                      <Typography color="error" fontSize={13} mt={0.5}>
                        {formErrors.healthInfoTo}
                      </Typography>
                    )}
                  </Box>
                </Box>

                {/* Health Info Type */}
                <Box mb={3}>
                  <Typography
                    fontSize={15}
                    fontWeight={400}
                    color="var(--app-text-muted)"
                    mb={1}
                  >
                    Health Info Type <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <Select
                    options={getHealthInfoTypeOptions()}
                    isMulti
                    styles={customStyles}
                    formatOptionLabel={formatOptionLabel2}
                    value={selectedHealthInfoTypes}
                    onChange={handleHealthInfoTypeChange}
                    placeholder="Select health info types"
                    closeMenuOnSelect={false}
                  />

                  {formErrors.healthInfoType && (
                    <Typography color="error" fontSize={13} mt={0.5}>
                      {formErrors.healthInfoType}
                    </Typography>
                  )}
                </Box>

                {/* Purpose */}
                <Box mb={3}>
                  <Typography
                    fontSize={15}
                    fontWeight={400}
                    color="var(--app-text-muted)"
                    mb={1}
                  >
                    Purpose of Consent <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <Box
                    component="select"
                    value={consentPurposeCode}
                    onChange={(e) => setConsentPurposeCode(e.target.value)}
                    sx={{
                      width: "100%",
                      height: 48,
                      borderRadius: 1.5,
                      border: "1px solid var(--app-border)",
                      px: 2,
                    }}
                  >
                    <option value="">Select purpose of consent</option>
                    <option value="CAREMGT">CAREMGT</option>
                  </Box>

                  {formErrors.consentPurposeCode && (
                    <Typography color="error" fontSize={13} mt={0.5}>
                      {formErrors.consentPurposeCode}
                    </Typography>
                  )}
                </Box>

                {/* Expiry */}
                <Box mb={4}>
                  <Typography
                    fontSize={15}
                    fontWeight={400}
                    color="var(--app-text-muted)"
                    mb={1}
                  >
                    Consent Expiry Date and Time{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      format="dd/MM/yyyy HH:mm"
                      ampm={false}
                      value={consentExpiryDateTime}
                      onChange={setConsentExpiryDateTime}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          placeholder: "DD/MM/YYYY HH:MM",
                        },
                      }}
                    />
                  </LocalizationProvider>

                  {formErrors.consentExpiry && (
                    <Typography color="error" fontSize={13} mt={0.5}>
                      {formErrors.consentExpiry}
                    </Typography>
                  )}
                </Box>
              </>
            ) : (
              selectedCentre && (
                <Box>
                  <Box
                    sx={{
                      bgcolor: "#fff4e5",
                      color: "#663c00",
                      p: 2,
                      borderRadius: 2,
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    <strong>Warning:</strong> The centre is not ABHA verified.
                    Please verify before requesting consent.
                  </Box>
                </Box>
              )
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {selectedCentre != null && selectedCentre?.isAbhaVerified && (
            <Button
              onClick={handleConsentSubmit}
              className="btn btn-added-primary w-100"
              disabled={submittingConsent}
            >
              {submittingConsent ? "Requesting…" : "Request Consent"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default PatientABHA;
const CalendarIcon = () => <Icon icon="uiw:date" width="20" height="20" />;
